import isEmpty from "lodash/isEmpty";
import React from "react";
import { useForm } from "react-hook-form";

import { fileExtension } from "../../../../utils/helpers/misc.helper";
import { DocFile, Error } from "../../../../utils/types/documents.type";
import { DocumentsState } from "../../types/hook.types";

type Tags = {
  investor?: string;
  fund?: string;
  quarter?: string;
};

const useEditPanel = (state: DocumentsState | null, props: any) => {
  const [loading, setLoading] = React.useState<boolean>(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
    getValues,
    setValue,
    reset,
    watch,
    setError
  } = useForm<Tags>();

  const resetForm = () => {
    setLoading(false);
    reset();
  };

  const handleSave = (data: any) => {
    const { investor, fund, quarter } = data;
    const errorProneFiles: Array<Error> = [];

    const tagFields = {
      investorId: investor,
      fundId: fund,
      quarterId: quarter,
    };
    
    const fileParams = {
      fileIds: props.files?.map((file:any) => file.id),
      ...tagFields
    };

    if(state?.currentFolder?.id) {
      setLoading(true);
      props.addFileTags({
        folderId: state.currentFolder.id,
        ...fileParams
      }).then((res: any) => {
        setLoading(false);
        if(!isEmpty(res.failedFiles)) {
          //handle error
          for(const i in res.failedFiles) {
            errorProneFiles.push({
              id: i,
              label: i,
              errorMsg: res.failedFiles[i],
              iconType: fileExtension(i),
            });
          }
          props.setErrors(errorProneFiles);
          resetForm();
          props.handleClose();
          return;
        }
        resetForm();
        props.handleClose();
      }).catch(() => {
        setLoading(false);
      });
    }
  };

  const onClose = () => {
    if(loading) return;
    resetForm();
    props.handleClose();
  };
  
  const getInvestors = (): Array<any>  => state?.filtersData.investors.filter(investor => investor.id !== "(none)").map(investor => ({ label: investor.name, value: investor.id })) ?? [];
  const getFunds = (): Array<any>  => state?.filtersData.funds.filter(fund => fund.id !== "(none)").map(fund => ({ label: fund.name, value: fund.id })) ?? [];
  const getQuarters = (): Array<any>  => state?.filtersData.quarters.filter(quarter => quarter.id !== "(none)").map(quarter => ({ label: quarter.name, value: quarter.id })) ?? [];

  return {
    loading,
    register,
    errors,
    control,
    handleSubmit,
    handleSave,
    getInvestors,
    getFunds,
    getQuarters,
    getValues,
    setValue,
    resetForm,
    reset,
    watch,
    onClose,
  };
};

export default useEditPanel;